
const valueFor = (row, column) => {
  if (column.render) {
    return column.render(row);
  }

  return row?.[column.key] ?? "--------";
};

const ReportDataTable = ({
  columns,
  rows = [],
  emptyMessage,
  loading,
  className = "",
}) => (
  <div className={`report-data-table-wrap ${className}`.trim()}>
    <table className="report-data-table">
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key || column.label}>{column.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td className="report-table-empty" colSpan={columns.length}>
              Loading report data...
            </td>
          </tr>
        ) : rows.length ? (
          rows.map((row, index) => (
            <tr key={row.id || row.log_id || row.order_id || row.phone || index}>
              {columns.map((column) => (
                <td key={column.key || column.label}>{valueFor(row, column)}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td className="report-table-empty" colSpan={columns.length}>
              {emptyMessage || "No report data found."}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default ReportDataTable;
